import IconError from '@bubble-ui/icon-error';
import IconWarning from '@bubble-ui/icon-warning';
import IconInformation from '@bubble-ui/icon-information';
export var getIconType = _ref => {
  var {
    error,
    Icon,
    warning
  } = _ref;
  return Icon ? Icon : error ? IconError : warning ? IconWarning : IconInformation;
};
var arrowHeadToTooltipCorner = 20;
export var getArrowDetails = arrow => {
  var arrowDirection = 'top';
  var arrowAlign = 'right';
  if (arrow) {
    ;
    [arrowDirection, arrowAlign] = arrow.split('-');
    arrowAlign = arrowAlign || 'center';
  }
  return {
    arrowDirection,
    arrowAlign
  };
};
export var getTooltipTopPosition = _ref2 => {
  var {
    arrowAlign,
    arrowDirection,
    parentHeight,
    tooltipHeight,
    parentTopPos
  } = _ref2;
  return arrowDirection === 'top' ? parentTopPos + parentHeight : arrowDirection === 'bottom' ? tooltipHeight > 0 ? parentTopPos - tooltipHeight : 0 :
  // ['left', 'right'].includes(arrowDirection)
  arrowAlign === 'top' ? parentTopPos + parentHeight / 2 - arrowHeadToTooltipCorner : arrowAlign === 'bottom' ? parentTopPos + parentHeight / 2 - tooltipHeight + arrowHeadToTooltipCorner :
  // arrowAlign === 'center'
  parentTopPos + parentHeight / 2 - tooltipHeight / 2;
};
export var getTooltipLeftPosition = _ref3 => {
  var {
    arrowAlign,
    arrowDirection,
    parentWidth,
    tooltipWidth,
    parentLeftPos
  } = _ref3;
  return arrowDirection === 'left' ? parentLeftPos + parentWidth : arrowDirection === 'right' ? parentLeftPos - tooltipWidth :
  // ['top', 'bottom'].includes(arrowDirection)
  arrowAlign === 'left' ? parentLeftPos + parentWidth / 2 - arrowHeadToTooltipCorner : arrowAlign === 'right' ? parentLeftPos - tooltipWidth + parentWidth / 2 + arrowHeadToTooltipCorner :
  // arrowAlign === 'center'
  parentLeftPos - tooltipWidth / 2 + parentWidth / 2;
};
var viewportHorizontalPadding = 15;
export var getMaxWidth = _ref4 => {
  var {
    arrowAlign,
    arrowDirection,
    parentWidth,
    parentLeftPos,
    viewportWidth
  } = _ref4;
  return arrowDirection === 'right' ? parentLeftPos - viewportHorizontalPadding : arrowDirection === 'left' ? viewportWidth - parentLeftPos - parentWidth - viewportHorizontalPadding :
  // ['top', 'bottom'].includes(arrowDirection)
  arrowAlign === 'right' ? parentLeftPos + parentWidth / 2 - viewportHorizontalPadding + arrowHeadToTooltipCorner : arrowAlign === 'left' ? viewportWidth - parentLeftPos - parentWidth / 2 - viewportHorizontalPadding + arrowHeadToTooltipCorner :
  // arrowAlign === 'center'
  parentLeftPos <= viewportWidth - parentLeftPos - parentWidth / 2 ? (parentLeftPos + parentWidth / 2 - viewportHorizontalPadding) * 2 : (viewportWidth - parentLeftPos - parentWidth / 2 - viewportHorizontalPadding) * 2;
};
//# sourceMappingURL=utils.js.map